import account from './account';
import roles from './roles';

export default (siteName) => [
    ...account(siteName),
    ...roles(siteName),
    {
        path: 'department',
        name: 'department',
        component: () => import('../../components/dashboard/Settings/DepartmentSetting/index'),
        meta: {
            title: `部門管理${siteName}`,
            activeMenu: 'admin',
        },
    },
];
